import { readingSourceIndex } from '@mio/shared';
import GithubSlugger from 'github-slugger';

export interface OutlineEntry {
  id: string;
  title: string;
}

/**
 * The second-level headings of a Markdown body with the ids rehype-slug will assign,
 * so an in-page outline links to the rendered sections. Code fences are skipped.
 */
export function outlineOf(markdown: string): OutlineEntry[] {
  return headingsOf(markdown)
    .filter((heading) => heading.level === 2)
    .map(({ id, title }) => ({ id, title }));
}

/** All heading anchors, including subheadings used by lesson reference links. */
export function headingsOf(
  markdown: string,
): (OutlineEntry & { level: number; sourceLine: number })[] {
  const slugger = new GithubSlugger();
  return readingSourceIndex(markdown).headings.map((heading) => ({
    id: slugger.slug(heading.title),
    title: heading.title,
    level: heading.level,
    sourceLine: heading.sourceLine,
  }));
}
